































































































import Vue, { VueConstructor } from 'vue';
import { mapGetters, mapState } from 'vuex';

import portalMixin from '@/mixins/portalMixin';
import LocationService from '@/services/LocationService';
import MarkdownText from '@/components/ui/MarkdownText.vue';


interface TermsAgreement {
	isLoading: boolean;
	location: Locations.Location;
	value: boolean;
	type: string;
	tos: string;
	showTos: boolean;
	showAgreement: boolean;
	confirmMessage: string;
	recurring: boolean;
}

export default (Vue as VueConstructor<Vue & TermsAgreement>).extend({
	name: 'TermsAgreement',
	mixins: [portalMixin],
	props: {
		agreeButton: String,
		confirmMessage: String,
		showAgreement: Boolean,
		recurring: Boolean,
		showTos: Boolean,
		tos: String,
		type: {
			type: String,
			default: '',
		},
		value: Boolean,
	},

	components: {
		MarkdownText,
	},


	data() {
		return {
			mode: 'read' as string,
			terms: '' as string,
		};
	},

	computed: {
		...mapState(['isLoading']),
		...mapGetters('location', ['location']),

		currentTerms(): string {
			return this.tos || this.terms;
		},

		model: {
			get(): boolean {
				return this.value;
			},
			set(value: boolean) {
				this.$emit('input', value);
			},
		},
	},

	watch: {
		currentTerms: {
			handler(value, oldValue) {
				if (!value) {
					(this as any).$emit('update:hasTos', false);
				}

				if (value && !oldValue) {
					(this as any).$emit('update:hasTos', true);
				}
			},
			immediate: true,
		},
		location: {
			handler() {
				(this as any).loadTos();
			},
			immediate: true,
		},
		showAgreement(value: boolean) {
			if (value) {
				(this as any).toggleAgreement();
			}
		},
		showTos(value: boolean) {
			if (value) {
				(this as any).toggleRead();
			}
		},
	},

	methods: {
		agreeToTos() {
			this.model = true;
			this.$emit('agree', true);
			this.$modal.hide('tos');
			this.uxAction('Agree to Terms');
			this.$store.dispatch('googleEvents/clickedBookReservationFromTOS', {
				fromInfo: '',
			});
		},

		declineTos() {
			this.model = false;
			this.$emit('agree', false);
			this.$modal.hide('tos');
			this.uxAction('Decline Terms');
			this.$store.dispatch('googleEvents/clickedCancelReservationFromTOS', {
				fromInfo: '',
			});
		},

		async loadTos() {
			if (!this.location.codeID) {
				return;
			}

			this.terms = await LocationService.fetchTerms({
				location: this.location.codeID as string,
				type: this.type as string,
			});
		},

		toggleAgreement() {
			this.mode = 'agree';
			this.$emit('update:showAgreement', false);
			this.$modal.show('tos');
		},

		toggleRead() {
			this.mode = 'read';
			this.$emit('update:showTos', false);
			this.$modal.show('tos');
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'showTos',
				fromInfo: '',
			});
		},

		clickedToClose() {
			if (this.mode !== 'agree') {
				this.$store.dispatch('googleEvents/genericButtonPressed', {
					buttonName: 'closeTOS',
					fromInfo: '',
				});
			}
		},

		uxAction(value: string) {
			this.$store.dispatch('analytics/action', {
				type: 'UX',
				label: 'click',
				value,
				step: this.$store.state.reservation.step,
			} as Analytics.ActionParams);
		},
	},
});
